import React, { useState, useEffect } from "react";
import axios from "axios";
import "antd/dist/antd.css";
import withAuthRedirect from "../components/withAuthRedirect";
import Hotel from "../components/Hotel";
import Loader from "../components/Loader";
import Error from "../components/Error";

import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init({
  duration: 1000,
});


function HotelHomescreen() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [hotels, setHotels] = useState([]);

  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [duplicateHotels, setDuplicateHotels] = useState([]);
  const [searchKey, setSearchKey] = useState("");

  useEffect(() => {
    async function fetchMyAPI() {
      try {
        setError("");
        setLoading(true);
        const data = (await axios.get("/api/hotels/getallhotels")).data;
        //console.log(data);
        setHotels(data);
        setDuplicateHotels(data);
      } catch (error) {
        console.log(error);
        setError(error);
      }
      setLoading(false);
    }

    fetchMyAPI();
  }, []);


  function filterBySearch() {
    const tempHotels = duplicateHotels.filter((x) =>
      x.name.toLowerCase().includes(searchKey.toLowerCase())
    );
    setHotels(tempHotels);
  }

  return (
    <><div className="container">
          <div className="row mt-5 bs">
                  <input
                      type="text"
                      className="form-control"
                      placeholder="Search Hotel"
                      value={searchKey}
                      onChange={(e) => {
                          setSearchKey(e.target.value);
                      } }
                      onKeyUp={filterBySearch} />
          </div>

          <div className="row justify-content-center mt-5">
              {loading ? (
                  <Loader></Loader>
              ) : error.length > 0 ? (
                  <Error msg={error}></Error>
              ) : (
                  hotels.map((x) => {
                      return (
                          <div className="col-md-9 mt-3" data-aos="zoom-down" key={x._id}>
                              <Hotel hotel={x} key={x._id} fromDate={fromDate} toDate={toDate} />
                          </div>
                      );
                  })
              )}
          </div>
      </div></>
  );
}

export default withAuthRedirect(HotelHomescreen);
